<template>
  <div
    class="flex items-center justify-center text-white p-1 px-2 rounded-lg shrink-0 transition-all snap-center"
    :class="active ? 'bg-yellow-400 transform scale-125' : 'bg-red-700'"
    @click="$emit('dayClicked', day)"
    ref="day"
  >
    <div class="text-center">
      <p class="font-bold text-sm">{{ renderDay }}</p>
      <p class="text-[0.5rem]">{{ renderDayName }}</p>
    </div>
  </div>
</template>

<script>
import jDate from "jalali-date";

export default {
  name: "DayViewer",
  emits: ["dayClicked"],
  props: ["month", "day", "active"],
  computed: {
    renderDay() {
      if (this.day < 10) {
        return "0" + this.day;
      }

      return this.day;
    },
    renderDayName() {
      let today = new jDate();
      let date = new jDate(today.getFullYear(), this.month, this.day);
      return date.format("dddd");
    },
  },
  mounted() {
    if (this.active) {
      this.$refs.day.scrollIntoView({
        inline: "center",
      });
    }
  },
};
</script>

<style scoped></style>
